import * as React from 'react';
import { __ } from 'react-i18n';
import styled from 'styled-components';
import { FormInput, FormWrapper } from './FormInput';

interface Props {
  city: string;
  zip: string;
  onChange: string;
}

function CityZip({ city, zip, onChange }: Props) {
  return (
    <CityZipWrapper>
      <FormInput
        name="city"
        type="text"
        label={__('Mesto')}
        value={city}
        maxWidth={100}
        maxWidthPx={224}
        maxWidthMobilePx={224}
        marginRight={16}
        shrink={1}
        onChange={onChange}
        required={true}
      />
      <FormInput
        name="zip"
        type="text"
        label={__('PSČ')}
        value={zip}
        maxWidth={34}
        maxWidthPx={80}
        maxWidthMobilePx={80}
        onChange={onChange}
        required={true}
      />
    </CityZipWrapper>
  );
}

const CityZipWrapper = styled(FormWrapper)`
  ${({ theme }) => theme.mediab.m810`
    flex-flow: row nowrap;
    margin-right: 0;
  `}
`;

export { CityZip };
